export default "__VITE_ASSET__Dxf$msHc__"